import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
import PropTypes from 'prop-types';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export default function TcaSnackbar(props) {
  // captura props
  const { openInput, mensajeVizualizar, colorProceso, handleClose } = props;
  // ACTIONS
  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={() => handleClose()} />
      <IconButton
        size="small"
        aria-label="close"
        color='success'
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={openInput}
        autoHideDuration={4000}
        onClose={handleClose}
        // message={mensajeVizualizar}
        action={action}
        key={{ vertical: 'top', horizontal: 'right' }}
      // color={colorProceso}
      >
        <Alert onClose={handleClose} severity={colorProceso} sx={{ width: '100%' }}>
          {mensajeVizualizar}
        </Alert>
      </Snackbar>
    </div>
  );
}
TcaSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  mensajeVizualizar: PropTypes.string
};